
























































import Vue from 'vue'

import firebase from 'firebase/app'
import 'firebase/database'

import Header from '@/components/widgets/bar/Header.vue'
import DialogRoom from '@/components/widgets/dialog/DialogRoom.vue'
import Footer from '@/components/widgets/footer/Footer.vue'

export default Vue.extend({
  name: 'Home',

  components: {
    Header,
    DialogRoom,
    Footer,
  },

  computed: {
    record(): number {
      return Number(localStorage.getItem('record'))
    }
  },
})
